import React, { FC } from 'react';
import { GenExternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import { TypeAccountSettingsPageTranslations } from '@/utils/translations';
import { TypeUserRecord } from '@/lib/api/accountManager/types';
import { TypeExternalPaymentMethod } from '@/lib/api/productCatalog/types';

export type PaymentMethodTileProps = {
  t: TypeAccountSettingsPageTranslations;
  user: TypeUserRecord;
  paymentMethod: TypeExternalPaymentMethod | undefined;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
};

const PaymentMethodTile: FC<PaymentMethodTileProps> = ({
  t,
  user,
  paymentMethod,
  tile,
  locale,
}) => {
  // non subscriber accounts or users with only a partial subscription (i.e. babylist / gift activations)
  // will not have a payment method on file, in which case we won't display this tile.
  if (!paymentMethod) return null;

  const editPaymentMethodLink = constructLegacyCustomerPortalLink(locale, [
    user.uuid,
    'account-settings',
    'payment-method',
  ]);

  return (
    <GenNavTile
      title={tile.title}
      subTitle={tile.subheader}
      description={tile.description}
      titleDecorator={
        <GenExternalLink href={editPaymentMethodLink} cta={t.editCta} />
      }
    >
      <p>{paymentMethod.localized_label}</p>
    </GenNavTile>
  );
};

export default React.memo(PaymentMethodTile);
